module.exports = __webpack_public_path__ + "static/media/meme3.4b0ef6d5.png";